module.exports = __webpack_public_path__ + "fonts/Farmacia.32db90e.woff";